import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CarrierLoadDocumentService,
  CarrierLoadModel,
  LoadDocumentType
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class CarrierLoadDocumentApiService {
  constructor(private apiService: CarrierLoadDocumentService) {}

  public deleteDocument(loadId: string, documentId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadDocumentDelete(loadId, documentId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editDocument(loadId: string, documentId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadDocumentEdit(loadId, documentId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public addLoadExtraDocument(loadId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadExtraDocumentAdd(loadId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public addLoadStopDocument(loadId: string, stopId: string, documentType: LoadDocumentType, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadStopDocumentAdd(loadId, stopId, documentType, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
